import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { AppNotification } from "@/model/data/notifications/AppNotification";
import { OneTimeCodeNotification } from "@/model/data/notifications/OneTimeCodeNotification";
import { SecurityNotification } from "@/model/data/notifications/SecurityNotification";
import { UpdateResultNotification } from "@/model/data/notifications/UpdateResultNotification";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetNotificationsResData extends ServiceResponseData {
    notifications: AppNotification[];
    distinctDevices: string[];

    constructor(response: AxiosResponse) {
        super(response);
        this.notifications = [];
        this.distinctDevices = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    parse(obj: any) {
        if (obj.Notifications && obj.Notifications.length > 0) {
            obj.Notifications.forEach((e) => {
                if (e.NotificationType == NotificationTypesEnum.Update) this.notifications.push(new UpdateResultNotification(e));
                if (e.NotificationType == NotificationTypesEnum.Security) this.notifications.push(new SecurityNotification(e));
                if (e.NotificationType == NotificationTypesEnum.OneTimeCode) this.notifications.push(new OneTimeCodeNotification(e));
            });
        }

        if (obj.DistinctDevices && obj.DistinctDevices.length > 0) {
            obj.DistinctDevices.forEach((e) => {
                this.distinctDevices.push(e);
            });
        }
    }
}
